import { track } from '@tldraw/tldraw'
import Styles from './ProcessingShapeOverlay.module.scss'
import { ProcessingShapeOverlayProps } from './Types'
import { observer } from 'mobx-react-lite'
import { ShapeOverlay } from '../ShapeOverlay/ShapeOverlay'

export const ProcessingShapeOverlay = track(
  observer(({ shape }: ProcessingShapeOverlayProps) => {
    return (
      <ShapeOverlay shape={shape} className={Styles.processingShapeOverlay}>
        <div className={Styles.loader} />
      </ShapeOverlay>
    )
  }),
)
